import { createContext, useContext, useEffect, useState } from "react";

const AccountingSidebarContext = createContext();

export const AccountingSidebarProvider = ({ children }) => {
    const [collapsed, setCollapsed] = useState(() => {
        return localStorage.getItem("accountingSidebarCollapsed") === "true";
    });

    useEffect(() => {
        localStorage.setItem(
            "accountingSidebarCollapsed",
            String(collapsed)
        );
    }, [collapsed]);

    const toggleCollapsed = () => {
        setCollapsed((prev) => !prev);
    };

    return (
        <AccountingSidebarContext.Provider
            value={{
                collapsed,
                setCollapsed,
                toggleCollapsed,
            }}
        >
            {children}
        </AccountingSidebarContext.Provider>
    );
};

export const useAccountingSidebar = () => {
    const context = useContext(AccountingSidebarContext);

    if (!context) {
        throw new Error(
            "useAccountingSidebar must be used within an AccountingSidebarProvider"
        );
    }

    return context;
};